// @flow

import { createRelayEnvironment } from './relayEnvironment';

export { createRelayEnvironment };
